import { render, staticRenderFns } from "./GroupUserItem.vue?vue&type=template&id=ccc55eb2&scoped=true&"
import script from "./GroupUserItem.vue?vue&type=script&lang=js&"
export * from "./GroupUserItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupUserItem.vue?vue&type=style&index=0&id=ccc55eb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc55eb2",
  null
  
)

export default component.exports